import CardItem from 'components/card-item/card-item';

export default CardItem;
